/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lower_Real_Felix_NurtureInputs */

const fr_lower_real_felix_nurture = /** @type {(inputs: Lower_Real_Felix_NurtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de la suppression du WOD`)
};

/**

* @param {Lower_Real_Felix_NurtureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lower_real_felix_nurture = /** @type {((inputs?: Lower_Real_Felix_NurtureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lower_Real_Felix_NurtureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lower_real_felix_nurture(inputs)
});